import React from "react";
import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import Banner from "../components/Banner";
import Services from "../components/Services";
import FeaturedBusinesses from "../components/FeaturedBusinesses";
const home = () => {
  return (
    <>
      <Hero>
        <Banner
          title="DBI Businesses for Sale"
          subtitle="Serving Texas for over 20 years"
        >
          <Link to="/businesses" className="btn-primary">
            our listings
          </Link>
        </Banner>
      </Hero>
      <Services />
      <FeaturedBusinesses />
    </>
  );
};

export default home;
